import styled from 'styled-components';
import {GrEmoji} from 'react-icons/gr';

export const Iosmile = styled(GrEmoji)`
  color: #BD04FD;
`
